const dispatchedEvents: Event[] = [];

/*
 This function wraps document.dispatchEvent and adds more behavior to it. Specifically, it records all the events in an
 array so that listeners of the events (once initialized) can check if they missed past events.
 Here's a more concrete example that demonstrates when you'd want to use it:
 - There's a sign-in modal that must be shown if the URL contains a param (?signIn=true)
 - There's a script that runs upon initialization to check for the param and dispatch the event to open the modal
 - *However* the SignInModal React component is not ready yet
 - Once the SignInModal React component is ready, it can check for past events to see if the modal should have been
 opened (via `getPastEvent`).
 */
export const dispatchRecordedEvent = (event: Event) => {
  dispatchedEvents.push(event);
  document.dispatchEvent(event);
};

export const getPastEvent = (eventType: string): Event | undefined => {
  return dispatchedEvents.find((e) => e.type === eventType);
};
